import React, { createContext, useMemo, useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import vision74Logo from '../assets/vision74-logo.jpg';
import tplLogo from '../assets/tpl-logo.png';
import hughesLogo from '../assets/hughes-logo.png';
import defaultLogo from '../assets/default-logo.png';
import tplDarkLogo from '../assets/tpl-dark-logo.png';
import hughesDarkLogo from '../assets/hughes-dark-logo.png';
import { light } from '@mui/material/styles/createPalette';

export const HomeThemeContext = createContext({ homeId: 'default', setHomeId: () => {}, config: {} });

export const HOMES = {
  vision74: {
    id: 'vision74',
    title: 'Vision 74',
    light_logo: vision74Logo,
    dark_logo: vision74Logo,
    flags: { showPromo: true, showExtraImage: true }
  },
  tpl: {
    id: 'tpl',
    title: 'Toronto Public Library',
    light_logo: tplLogo,
    dark_logo: tplDarkLogo,
    flags: { showPromo: false, showExtraImage: false }
  },
  hughes: {
    id: 'hughes',
    title: 'Hughes',
    light_logo: hughesLogo,
    dark_logo: hughesDarkLogo,
    flags: { showPromo: false, showExtraImage: false }
  },
  default: {
    id: 'default',
    title: 'Care Passport',
    light_logo: "https://images.unsplash.com/photo-1527181152855-fc03fc7949c8?auto=format&w=1000&dpr=2",
    dark_logo: "https://images.unsplash.com/photo-1572072393749-3ca9c8ea0831?auto=format&w=1000&dpr=2",
    flags: { showPromo: false, showExtraImage: false }
  }
};


export default function HomeThemeProvider({ children }) {
  const { home } = useParams();
  const location = useLocation();
  const [homeId, setHomeId] = useState('default');

  useEffect(() => {
    if (location.pathname.match(/^\/(\w+)?\/?login/)) {
      setHomeId(home || '');
    }
  }, [home, location.pathname]);

  const config = useMemo(() => HOMES[homeId] || HOMES.default, [homeId]);

  return (
    <HomeThemeContext.Provider value={{ homeId, setHomeId, config }}>
      {children}
    </HomeThemeContext.Provider>
  );
}

export const useHomeTheme = () => React.useContext(HomeThemeContext);
